// Router-link usa el slug para viajar a las rutas.
// Vue-router y esta lista se conecta a través del 'url'
// isDisabled: true / false
// rule: indica qué roles son aceptados para mostrar este ítem en el navbar (vertical u horizontal)
//   si un rol no está indicado dentro del array, para los usuarios con dicho rol no se mostrará ese elemento.

export default [
  {
    url: '/',
    name: 'Inicio',
    slug: 'Inicio',
    icon: 'BarChartIcon',
    isDisabled: false,
    rule: ['asesor', 'admin']  
  },
  {
    // DASHBOARD CLIENTE
    url: '/dashboard-cliente',
    name: 'Inicio',
    slug: 'dashboard-cliente',
    icon: 'BarChartIcon',
    isDisabled: false,
    rule: ['public', 'client']
  },
  // {
  //   url: '/admin/mis-clientes',
  //   name: 'Mis Clientes',
  //   slug: 'mis-clientes',
  //   icon: 'UsersIcon',
  //   isDisabled: false,
  //   rule: ['asesor', 'admin']
  // },
  {
    header: 'Extranjería',
    icon: 'FlagIcon',
    rule: ['client', 'asesor', 'admin'],
    items: [
      {
        url: '/extranjeria',
        name: 'Estatus Extranjería',
        slug: 'extranjeria',
        icon: 'FlagIcon',
        isDisabled: false,
        rule: ['client']
      },
      // ON HOLD
      /*
      {
        url: '/tramite-nacionalidad-espanola',
        name: 'Consulta tu expediente',
        slug: 'nacionalidad',
        icon: 'ActivityIcon',
        isDisabled: false,
        rule: ['client']
      },
      */
      // ON HOLD
      {
        url: '/tramite-proteccion-internacional',
        name: 'Consulta tu solicitud',
        slug: 'proteccion-internacional',
        icon: 'ShieldIcon',
        isDisabled: false,
        rule: ['client']
      },
      {
        url: '/admin/visas-y-documentos',
        name: 'Visas - Docs - Pasos',
        slug: 'visas-y-documentos',
        icon: 'SettingsIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      }   
    ]
  },
  {
    header: 'Vive en España',
    icon: 'FlagIcon',
    rule: ['client'],
    items: [
      {
        url: '/guia-de-barrios',
        name: 'Dónde Vivir',
        slug: 'guia-barrios',
        icon: 'CompassIcon',
        isDisabled: false,
        rule: ['client']
      },
      {
        url: '/guias-de-integracion',
        name: 'Cómo Empezar',
        slug: 'guia-integracion',
        icon: 'MapIcon',
        isDisabled: false,
        rule: ['client']
      },
      {
        url: '/ofertas-laborales',
        name: 'Ofertas laborales',
        slug: 'extranjeria',
        icon: 'BriefcaseIcon',
        isDisabled: false,
        rule: ['client']
      }
    ]
  },
  {
    header: 'Gestión Usuarios',
    icon: 'UsersIcon',
    rule: ['asesor', 'admin'],
    items: [
      {
        url: '/admin/empleados',
        name: 'Empleados',
        slug: 'admin.empleados',
        icon: 'UsersIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      }, 
      {
        url: '/admin/clientes',
        name: 'Clientes',
        slug: 'admin.clientes',
        icon: 'UsersIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      },
      {
        url: '/admin/clientes-extranjeria',
        name: 'Clientes Activos Extranjería',
        slug: 'admin.clientes-extranjeria',
        icon: 'UsersIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      },
      {
        url: '/admin/asesores',
        name: 'Asignación Asesores',
        slug: 'admin.asesores',
        icon: 'UsersIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      }
    ]
  }
  /*
  {
    header: 'Servicios',
    icon: 'PaperclipIcon',
    rule: ['asesor', 'admin'],
    items: [
      {
        url: '/admin/gestion-servicios',
        name: 'Gestión de Servicios',
        slug: 'admin.gestion-servicios',
        icon: 'PaperclipIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      }
    ]
  },
  {
    header: 'Contabilidad',
    icon: 'DollarSignIcon',
    rule: ['asesor', 'admin'],
    items: [
      {
        url: '/admin/pagos',
        name: 'Gestión de Pagos',
        slug: 'admin.pagos',
        icon: 'DollarSignIcon',
        isDisabled: false,
        rule: ['asesor', 'admin']
      }
    ]
  }
  */
]
